/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * CatalogAdapter.tsx
 */

import ListAdapter, {AdapterListener} from "../../tools/list/ListAdapter";
import Catalog from "../../models/Catalog";
import React from "react";
import {Column} from "../../tools/list/Column"
import Translation from "../../services/translation/Translation";
import CatalogDataProvider from "../../provider/CatalogDataProvider";
import {CatalogAPIPagination} from "../../pagination/CatalogAPIPagination";

export interface CatalogAdapterListener extends AdapterListener<Catalog> {
}

export default class CatalogAdapter extends ListAdapter<Catalog, CatalogAdapterListener, CatalogAPIPagination> {
    private _t: Translation;

    /**
     * constructor
     * @param catalogsProvider
     * @param listener
     * @param t
     */
    constructor(t: Translation, catalogsProvider: CatalogDataProvider, listener?: CatalogAdapterListener) {
        super();

        this._t = t;
        this.addColumn(new Column(t.catalogListColTitle, "title", this._title));

        this.init(
            t.catalogListEmpty,
            catalogsProvider,
            [],
            listener
        );
    }

    /**
     * _title
     * @returns {any}
     * @private
     * @param catalog
     */
    private _title = (catalog: Catalog): JSX.Element => {
        return <p className={"blue-hover"}>{catalog.title}</p>
    };
}